import {useState, useEffect} from 'react'

export function useWindowSize(): {
  width: number
  height: number
  isDesktop: boolean
} {
  const [windowSize, setWindowSize] = useState<{
    width: number
    height: number
  }>({
    width: 0,
    height: 0,
  })
  const [isDesktop, setIsDesktop] = useState<boolean>(false)

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
      setIsDesktop(window.innerWidth > 768)
    }

    window.addEventListener('resize', handleResize)

    handleResize()

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return {...windowSize, isDesktop}
}
